'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdverseEventService = function () {
  function AdverseEventService($http) {
    'ngInject';

    _classCallCheck(this, AdverseEventService);

    this.$http = $http;
  }

  _createClass(AdverseEventService, [{
    key: 'getAdverseEvent',
    value: function getAdverseEvent(id) {
      return this.$http.get('/api/ae/' + id);
    }
  }, {
    key: 'getInjurityProbabilities',
    value: function getInjurityProbabilities() {
      return [{
        name: '(+1) Extremely unlikely',
        value: 1
      }, {
        name: '(+2) Unlikely but possible',
        value: 2
      }, {
        name: '(+3) Likely',
        value: 3
      }, {
        name: '(+4) Very Likely',
        value: 4
      }, {
        name: '(+5) Extremely Likely',
        value: 5
      }];
    }
  }, {
    key: 'getInjuritySeverities',
    value: function getInjuritySeverities() {
      return [{
        name: '(+1) None – No symptoms reported.',
        value: 1
      }, {
        name: '(+2) Limited – Symptoms resolve quickly. Does not interfere with normal activities.',
        value: 2
      }, {
        name: '(+3) Moderate – Prolonged symptoms and/or interferes with the ability to perform normal activities.',
        value: 3
      }, {
        name: '(+4) Severe – Permanent injury or unable to perform normal activities.',
        value: 4
      }, {
        name: '(+5) Life threatening.',
        value: 5
      }];
    }
  }, {
    key: 'getOccurrenceLikelihoods',
    value: function getOccurrenceLikelihoods() {
      return [{
        name: '(+1) Remote - Only instance recorded',
        value: 1
      }, {
        name: '(+2) Rare - More than one instance (estimated 1 in 1000)',
        value: 2
      }, {
        name: '(+3) Occasional - Multiple instances (estimated 1 in 100)',
        value: 3
      }, {
        name: '(+4) Frequent - Estimated 1 in 10',
        value: 4
      }, {
        name: '(+5) Continuously occurring - More than 10% of the patients',
        value: 5
      }];
    }
  }, {
    key: 'getAnimalSexes',
    value: function getAnimalSexes() {
      var sexes = [{
        name: 'Male - Neutered / Gelding',
        value: 1
      }, {
        name: 'Male - Intact / Stallion',
        value: 2
      }, {
        name: 'Female - Spayed',
        value: 3
      }, {
        name: 'Female - Intact - Pregnant',
        value: 4
      }, {
        name: 'Female - Intact - Not Pregnant',
        value: 5
      }, {
        name: 'Male - Unknown',
        value: 6
      }, {
        name: 'Female - Unknown',
        value: 7
      }];

      return sexes.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    }
  }, {
    key: 'getSymptoms',
    value: function getSymptoms() {
      return ['Diarrhea', 'Stomach Upset/Vomiting', 'Colic (Horse)', 'Skin/Allergic Reaction', 'Seizures', 'Death', 'Lameness', 'Accidental Ingestion', 'Other'];
    }
  }, {
    key: 'getContactTypes',
    value: function getContactTypes() {
      return ['Owner', 'Vet', 'Other'];
    }
  }, {
    key: 'getStatuses',
    value: function getStatuses() {
      return ['OPEN', 'CLOSED'];
    }
  }, {
    key: 'getProductsByCompany',
    value: function getProductsByCompany(companyId) {
      return this.$http.get('/api/product/signed_by_member/' + companyId);
    }
  }, {
    key: 'update',
    value: function update(adverseEvent) {
      return this.$http.put('/api/ae/' + adverseEvent.AEId, _extends({}, adverseEvent, {
        Contacts: this.orderContacts(adverseEvent.Contacts)
      }));
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      return this.$http.delete('/api/ae/' + id);
    }
  }, {
    key: 'create',
    value: function create(adverseEvent) {
      return this.$http.post('/api/ae', _extends({}, adverseEvent, {
        Contacts: this.orderContacts(adverseEvent.Contacts)
      }));
    }
  }, {
    key: 'orderContacts',
    value: function orderContacts(contacts) {
      var tempContacts = [];
      if (!(contacts && contacts.length)) {
        return [];
      }

      var vetIndex = contacts.findIndex(function (c) {
        return c.Relationship === 'Vet';
      });
      var ownerIndex = contacts.findIndex(function (c) {
        return c.Relationship === 'Owner';
      });
      var otherIndex = contacts.findIndex(function (c) {
        return c.Relationship === 'Other';
      });

      if (vetIndex !== -1) {
        tempContacts.push(contacts[vetIndex]);
      }

      if (ownerIndex !== -1) {
        tempContacts.push(contacts[ownerIndex]);
      }

      if (otherIndex !== -1) {
        tempContacts.push(contacts[otherIndex]);
      }

      return tempContacts;
    }
  }, {
    key: 'attest',
    value: function attest(signature) {
      return this.$http.post('/api/ae/attest', {
        signature: signature
      });
    }
  }]);

  return AdverseEventService;
}();

exports.default = AdverseEventService;


// WEBPACK FOOTER //
// ./components/app/adverse-event/adverse-event.service.js